import { useState } from "react";
import { Link } from "react-router-dom";
import { Heart, MapPin } from "lucide-react";
import { formatPrice } from "@/lib/api";
import api from "@/lib/api";
import { SmartImage } from "@/components/SmartImage";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export function ListingCard({ listing, onFavoriteChange, priority = false }) {
  const { isAuthed } = useAuth();
  const [fav, setFav] = useState(listing.is_favorite);
  const image = listing.images?.[0];

  const toggleFav = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isAuthed) {
      toast.error("Log in om te bewaren");
      return;
    }
    try {
      const { data } = await api.post(`/listings/${listing.id}/favorite`);
      setFav(data.is_favorite);
      onFavoriteChange?.(listing.id, data.is_favorite);
    } catch {
      toast.error("Er ging iets mis");
    }
  };

  return (
    <Link
      to={`/advertentie/${listing.id}`}
      data-testid={`listing-card-${listing.id}`}
      className="group block overflow-hidden rounded-xl border border-[#333] bg-[#1c1c1c] transition-all duration-200 hover:-translate-y-1 hover:border-[#FF6A00]/60 hover:shadow-lg hover:shadow-black/50"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-[#2A2A2A]">
        <SmartImage src={image} alt={listing.title} width={600} priority={priority} blur={listing.images_blur?.[0]} sizes="(min-width: 1024px) 300px, (min-width: 640px) 30vw, 45vw" />
        {listing.distance_km != null && (
          <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-[#111]/80 px-2.5 py-1 text-xs font-semibold text-[#F5F5F5] backdrop-blur-sm">
            <MapPin className="h-3 w-3" /> {listing.distance_km} km
          </span>
        )}
        {listing.status === "reserved" && (
          <span className="absolute bottom-3 left-3 rounded-full bg-[#FFB27A] px-2.5 py-1 text-xs font-bold text-[#111]">Gereserveerd</span>
        )}
        {listing.status === "sold" && (
          <span className="absolute bottom-3 left-3 rounded-full bg-[#EF4444] px-2.5 py-1 text-xs font-bold text-white">Verkocht</span>
        )}
        <button
          data-testid={`favorite-btn-${listing.id}`}
          onClick={toggleFav}
          aria-label="Bewaar advertentie"
          className="absolute right-3 top-3 rounded-full bg-[#111]/80 p-2 backdrop-blur-sm transition-transform active:scale-90"
        >
          <Heart className={`h-4 w-4 ${fav ? "fill-[#FF6A00] text-[#FF6A00]" : "text-[#F5F5F5]"}`} />
        </button>
      </div>
      <div className="p-3">
        <h3 className="truncate font-semibold text-[#F5F5F5]" title={listing.title}>{listing.title}</h3>
        <p className="mt-1 font-display text-xl text-[#FF6A00]">{formatPrice(listing.price)}</p>
      </div>
    </Link>
  );
}
